import React from 'react'
import { URL_SRV } from '../router/Url';

export const AddAccount = ({valores}) => {
  // console.log(valores)
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV+'makeuser_ctrlhidrico',{
      method: 'POST',
      headers: {
        'authorization': "paico2021",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user: valores
      })
    })
    let responsito = await query.json();

    if(responsito.data.success){
      resolve(responsito.data)
    }else{
      resolve(responsito.data)
    }
  })
}
